import { Icon } from '@chakra-ui/react';
import { MdAccountBalanceWallet, MdBarChart, MdHome, MdManageAccounts, MdMoney, MdOutlineExitToApp, MdOutlineShoppingCart, MdPerson, MdSettings } from 'react-icons/md';

// Admin Imports
import Clients from 'views/admin/clients';
import ClientClassification from 'views/admin/clients/clientClassification';
import ClientTypeScreen from 'views/admin/clients/clientType';
import ConfigScreen from 'views/admin/config';
import DeptoScreen from 'views/admin/config/departament';
import DeptoOrcamentoScreen from 'views/admin/config/dptoOrcamento';
import CentroCustoScreen from 'views/admin/config/manageCenter';
import NewProductScreen from 'views/admin/config/newproduct';
import MainDashboard from 'views/admin/default';
import Finance from 'views/admin/finance';
import AccountType from 'views/admin/finance/accountType';
import BussinesModelScreen from 'views/admin/finance/bussinesModel';
import Categories from 'views/admin/finance/categorias';
import ComprasScreen from 'views/admin/finance/compras';
import ContaFinanceiro from 'views/admin/finance/contaFinanceiro';
import ContasPagarScreen from 'views/admin/finance/contas';
import ContasReberScreen from 'views/admin/finance/contasReceber';
import FinanceType from 'views/admin/finance/financetype';
import Occurrence from 'views/admin/finance/occurence';
import PaymentForm from 'views/admin/finance/paymentForm';
import SubCategoriesScreen from 'views/admin/finance/subCategories';
import Logout from 'views/admin/logout';
import Orders from 'views/admin/order';
import DescriptionScreen from 'views/admin/order/description';
import OrderFootNotesScreen from 'views/admin/order/footNotes';
import ItemTemplateScreen from 'views/admin/order/item_template';
import MeasureUnitScreen from 'views/admin/order/measureUnit';
import EntregavelOrderScreen from 'views/admin/order/orderEntregavel';
import ServicesOrderSceen from 'views/admin/order/orderServices';
import ProductOrderSceen from 'views/admin/order/product';
import Profile from 'views/admin/profile';
import ProjectScreen from 'views/admin/project';
import AprovedOrderScreen from 'views/admin/project/approved_order';
import FinanceProjectScreen from 'views/admin/project/finance_project';
import ProjectLaunchScreen from 'views/admin/project/launch';
import LauchedProjectScreen from 'views/admin/project/launched_project';
import ProjectManageScreen from 'views/admin/project/project_manage';
import TimeTrackerScreen from 'views/admin/project/time_tracker';
import Reports from 'views/admin/reports';
import NewUserScreen from "./views/admin/config/newUser";
import NewCompaniesScreen from "./views/admin/project/companies";
import {AdminRouteObject, generateRoute} from "./helpers/permission";


export const routes: AdminRouteObject = {
	default: {
		name: 'Dashboard',
		layout: '/admin',
		path: '/default/',
		icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
		component: MainDashboard,
		items: []
	},
	project: {
		name: 'Gestão de Projetos',
		layout: '/admin',
		path: '/project/',
		icon: <Icon as={MdAccountBalanceWallet} width='20px' height='20px' color='inherit' />,
		component: ProjectScreen,
	},
	manageProject: {
		name: 'Gestão Administrativa',
		layout: '/admin',
		icon: null,
		path: '/manage-project/',
		component: ProjectManageScreen,
	},
	approvedOrder: {
		name: 'Orcamentos Aprovados',
		layout: '/admin',
		icon: null,
		path: '/approved-order/',
		component: AprovedOrderScreen,
	},
	newProject: {
		name: 'Lancamento de Projetos',
		layout: '/admin',
		icon: null,
		path: '/new-project/',
		component: ProjectLaunchScreen,
	},
	projetoFinance: {
		name: 'Gestão Financeira de Projetos',
		layout: '/admin',
		icon: null,
		path: '/projetofinance/',
		component: FinanceProjectScreen,
	},
	launchedProject: {
		name: 'Projetos em Execução',
		layout: '/admin',
		icon: null,
		path: '/launched-project/',
		component: LauchedProjectScreen,
	},
	timeTracker: {
		name: 'Gestão de Tempo em Projetos',
		layout: '/admin',
		icon: null,
		path: '/time-tracker/',
		component: TimeTrackerScreen,
	},
	newCompanies: {
		name: 'Empresas',
		layout: '/admin',
		path: '/new-companies/',
		icon: null,
		component: NewCompaniesScreen,
	},
	order: {
		name: 'Orçamentos',
		layout: '/admin',
		path: '/order/',
		icon: <Icon as={MdOutlineShoppingCart} width='20px' height='20px' color='inherit' />,
		component: Orders,
	},
	templateItem: {
		name: 'Template de Itens de Orçamento',
		layout: '/admin',
		icon: null,
		path: '/template-item/',
		component: ItemTemplateScreen,
	},
	bussinesModel: {
		name: 'Modelos de Negócios',
		layout: '/admin',
		icon: null,
		path: '/bussines-model/',
		component: BussinesModelScreen,
	},
	description: {
		name: 'Descrições de Orçamento',
		layout: '/admin',
		icon: null,
		path: '/description/',
		component: DescriptionScreen,
	},
	midiaOrder: {
		name: 'Mídias',
		layout: '/admin',
		path: '/midia-order/',
		icon: null,
		component: ServicesOrderSceen,
	},
	entregavelOrder: {
		name: 'Entregáveis',
		layout: '/admin',
		path: '/entregavel-order/',
		icon: null,
		component: EntregavelOrderScreen,
	},
	productOrder: {
		name: 'Itens do Orçamento',
		layout: '/admin',
		path: '/product-order/',
		icon: null,
		component: ProductOrderSceen,
	},
	measureUnit: {
		name: 'Unidade de Medidas',
		layout: '/admin',
		path: '/measure-unit/',
		icon: null,
		component: MeasureUnitScreen,
	},
	footNotes: {
		name: 'Notas de Rodapé',
		layout: '/admin',
		path: '/foot-notes/',
		icon: null,
		component: OrderFootNotesScreen,
	},
	reports: {
		name: 'Relatórios',
		layout: '/admin',
		icon: <Icon as={MdBarChart} width='20px' height='20px' color='inherit' />,
		path: '/reports/',
		component: Reports,
	},
	finance: {
		name: 'Financeiro',
		layout: '/admin',
		icon: <Icon as={MdMoney} width='20px' height='20px' color='inherit' />,
		path: '/finance/',
		component: Finance,
	},
	accountType: {
		name: 'Tipo de Contas',
		layout: '/admin',
		icon: null,
		path: '/account-type/',
		component: AccountType,
	},
	contaFinanceira: {
		name: 'Cadastro de Contas',
		layout: '/admin',
		icon: null,
		path: '/conta-financeira/',
		component: ContaFinanceiro,
	},
	typeFinance: {
		name: 'Tipos de Lançamentos',
		layout: '/admin',
		icon: null,
		path: '/type-finance/',
		component: FinanceType,
	},
	// releasesFinance: {
	// 	name: 'Lançamentos',
	// 	layout: '/admin',
	// 	icon: null,
	// 	path: '/releases-finance/',
	// 	component: FinancialReleases,
	// },
	pedidoCompra: {
		name: 'Pedidos de Compra',
		layout: '/admin',
		icon: null,
		path: '/pedido-compra/',
		component: ComprasScreen,
	},
	contasPagar: {
		name: 'Contas a Pagar',
		layout: '/admin',
		icon: null,
		path: '/contas-pagar/',
		component: ContasPagarScreen,
	},
	contasReceber: {
		name: 'Contas a Receber',
		layout: '/admin',
		icon: null,
		path: '/contas-receber/',
		component: ContasReberScreen,
	},
	occurrence: {
		name: 'Ocorrências Financeiras',
		layout: '/admin',
		icon: null,
		path: '/occurrence/',
		component: Occurrence,
	},
	categorias: {
		name: 'Categorias Financeiras',
		layout: '/admin',
		icon: null,
		path: '/categorias/',
		component: Categories,
	},
	subcategories: {
		name: 'Subcategorias Financeiras',
		layout: '/admin',
		icon: null,
		path: '/subcategories/',
		component: SubCategoriesScreen,
	},
	paymentForm: {
		name: 'Condição de Pagamento',
		layout: '/admin',
		icon: null,
		path: '/payment-form/',
		component: PaymentForm,
	},
	clients: {
		name: 'Pessoas',
		layout: '/admin',
		path: '/clients/',
		icon: <Icon as={MdManageAccounts} width='20px' height='20px' color='inherit' />,
		component: Clients,
	},
	typeClients: {
		name: 'Tipo de Pessoas',
		layout: '/admin',
		path: '/type-clients/',
		icon: null,
		component: ClientTypeScreen,
	},
	classificationClients: {
		name: 'Classificação de Pessoas',
		layout: '/admin',
		path: '/classification-clients/',
		icon: null,
		component: ClientClassification,
	},
	config: {
		name: 'Configurações',
		layout: '/admin',
		path: '/config/',
		icon: <Icon as={MdSettings} width='20px' height='20px' color='inherit' />,
		component: ConfigScreen,
	},
	depto: {
		name: 'Departamentos',
		layout: '/admin',
		path: '/depto/',
		icon: null,
		component: DeptoScreen,
	},
	centroCusto: {
		name: 'Centro de Custos',
		layout: '/admin',
		path: '/centro-custo/',
		icon: null,
		component: CentroCustoScreen,
	},
	verbaDpto: {
		name: 'Planejamento Financeiro',
		layout: '/admin',
		path: '/verba-dpto/',
		icon: null,
		component: DeptoOrcamentoScreen,
	},
	newProducts: {
		name: 'Produtos',
		layout: '/admin',
		path: '/new-products/',
		icon: null,
		component: NewProductScreen,
	},
	newUsers: {
		name: 'Usuários',
		layout: '/admin',
		path: '/new-users/',
		icon: null,
		component: NewUserScreen,
	},
	profile: {
		name: 'Perfil',
		layout: '/admin',
		path: '/profile/',
		icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
		component: Profile,
		items: []
	},
	logoff: {
		name: 'Logout',
		layout: '/admin',
		path: '/logoff/',
		icon: <Icon as={MdOutlineExitToApp} width='20px' height='20px' color='inherit' />,
		component: Logout,
		items: []
	},
}

const adminRoutes = generateRoute(routes);

export default adminRoutes;
